import { getLocale } from "../runtime";

const sv_icontag = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tagg`
};

const icontag = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_icontag(inputs)
	return "iconTag";
};

export { icontag as "iconTag" };